import "./validate";
import "./filters";

import { TOKEN_NAME } from "@/global/global.js";

import App from "./App.vue";
import authService from "@/services/auth.js";
import DashboardPlugin from "./material-dashboard";
import router from "./router";
import store from "./store";

// import "@progress/kendo-ui";
// import "@progress/kendo-ui/js/cultures/kendo.culture.es-GT.js";
// import "@progress/kendo-theme-material/dist/all.css";

// import { DateinputsInstaller } from "@progress/kendo-dateinputs-vue-wrapper"; 
// import { GridInstaller } from "@progress/kendo-grid-vue-wrapper";

import Vue from "vue";
import VueClipboard from 'vue-clipboard2';
import vueJustgage from 'vue-justgage';
import VueScrollTo from 'vue-scrollto';
import axios from "axios";

import { ApmVuePlugin } from '@elastic/apm-rum-vue';

// kendo.culture("es-GT");
// Vue.use(GridInstaller);
// Vue.use(DateinputsInstaller);

Vue.config.productionTip = true;
Vue.config.performance = true;
Vue.config.devtools = true;
Vue.config.silent = false;

Vue.use(DashboardPlugin);
Vue.use(vueJustgage);
Vue.use(VueScrollTo, {
  container: '#main-panel',
  duration: 300
});

const moment = require('moment');
require('moment/locale/es');
Vue.use(require('vue-moment'), {
  moment
});

const api = axios.create({
  baseURL: process.env.VUE_APP_BASE_URL,
  withCredentials: false,
  credentials: "same-origin",
  mode: "no-cors",
  headers: {
    "content-type": "application/json",
    "Access-Control-Allow-Origin": "*",
    "Access-Control-Allow-Methods": "GET, PUT, POST, DELETE, OPTIONS"
  }
});

Vue.prototype.$http = api;

Vue.use(VueClipboard);

 router.beforeEach((to, from, next) => {let title = 'Surveys';
  if (to.meta.title && to.meta.title != '') {
    document.title = title + ' | ' + to.meta.title; 
  }
  else {
    document.title = title;
  }

  // Auth is required if the record has auth required = true or if the record
  // has at least one role allowed
  let authRequired = false;
  if (!authRequired) {
    // Auth not required, carry on
    next();
    return;
  }
  });

Vue.use(ApmVuePlugin, {
  router,
  config: {
    serviceName: 'surveys'
    , serverUrl: 'https://pfapi.xyz:8443'
    , distributedTracingOrigins: ['http://pf.tigo.com.gt/svy/']
  }
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
